import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../common/ConfirmationModal/ConfirmationModal';
import { useStudentSubmissionDispatch } from './StudentSubmissionPageContext';

const ReturnSubmissionConfirmationModal = ({ onConfirm }) => {
  const { t } = useTranslation();
  const dispatch = useStudentSubmissionDispatch();

  return (
    <div data-testid="confirmation-modal">
      <ConfirmationModal
        lang="en"
        loading={false}
        onClose={() => dispatch({ type: 'closeReturnSubmissionConfirmation' })}
        onConfirm={e => {
          dispatch({ type: 'closeReturnSubmissionConfirmation' });
          onConfirm(e);
        }}
        title={t('Confirm')}
        buttonTextConfirm={t('Yes')}
        buttonTextCancel={t('No')}
      >
        <span>
          {t(
            'Are you sure you want to return the grade/feedback to the student?',
          )}
        </span>
      </ConfirmationModal>
    </div>
  );
};

ReturnSubmissionConfirmationModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
};

export default ReturnSubmissionConfirmationModal;
